import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, concatMap, map, mergeMap, switchMap, toArray } from "rxjs/operators";
import { AdministratorService } from "src/app/_services/administrator.service";
import {
  DeleteAdministrators,
  DeleteAdministratorsError,
  DeleteAdministratorsSuccess,
  GetAdministratorListTable,
  GetAdministratorListTableError,
  GetAdministratorListTableSuccess,
  GetAdministratorTableLength,
  GetAdministratorTableLengthError,
  GetAdministratorTableLengthSuccess,
  ResetAdministratorTable,
  ResetAdministratorTableError,
  ResetAdministratorTableSuccess,
  UpdateAdminAccountStatus,
  UpdateAdminAccountStatusError,
  UpdateAdminAccountStatusSuccess,
  UpdateAdministratorTable,
  UpdateAdministratorTableError,
} from "./list-administrator.actions";
import { AdministratorList } from "src/app/_models/Administrator";
import { of } from "rxjs";
import { UserProfileService } from "src/app/_services/userprofile.service";

@Injectable()
export class ListAdministratorEffects {
  constructor(
    private action$: Actions,
    private administratorService: AdministratorService,
    private userProfileService: UserProfileService
  ) {}

  public getAdministratorTableEffect$ = createEffect(() =>
    this.action$.pipe(
      ofType(GetAdministratorListTable),
      switchMap((payload) =>
        this.administratorService
          .getAdministratorTableRecords$(
            payload.pageNumber,
            payload.isInitialLoad
          )
          .pipe(
            map((result: AdministratorList[]) => {
              return GetAdministratorListTableSuccess({ result: result });
            }),
            catchError((error: HttpErrorResponse) => {
              return of(
                GetAdministratorListTableError({
                  administratorTableError: error,
                })
              );
            })
          )
      )
    )
  );

  public getAdministratorTableLengthEffect$ = createEffect(() =>
    this.action$.pipe(
      ofType(GetAdministratorTableLength),
      switchMap(() =>
        this.administratorService.getAdministratorListLength$().pipe(
          map((length: number) => {
            return GetAdministratorTableLengthSuccess({ length: length });
          }),
          catchError((error: any) => {
            return of(GetAdministratorTableLengthError({ error: error }));
          })
        )
      )
    )
  );

  public updateAdministratorTableEffect$ = createEffect(() =>
    this.action$.pipe(
      ofType(UpdateAdministratorTable),
      switchMap((payload) =>
        this.administratorService
          .updateAdministratorTableRecords$(payload.params)
          .pipe(
            map(() => {
              return GetAdministratorListTable({
                pageNumber: payload.params.pageIndex,
                isInitialLoad: false,
              });
            }),
            catchError((error: any) => {
              return of(UpdateAdministratorTableError({ error: error }));
            })
          )
      )
    )
  );

  public resetAdministratorTableEffect$ = createEffect(() =>
    this.action$.pipe(
      ofType(ResetAdministratorTable),
      switchMap((payload) =>
        this.administratorService.resetAdministratorTable$().pipe(
          map(() => {
            return ResetAdministratorTableSuccess({
              isInitialLoad: payload.isInitialLoad,
            });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(ResetAdministratorTableError({ error: error }));
          })
        )
      )
    )
  );

  public deleteAdministratorEffect$ = createEffect(() => {
    return this.action$.pipe(
      ofType(DeleteAdministrators),
      switchMap((payload) => 
        this.administratorService.deleteAdministrator$(payload.userIdList).pipe(
          map(() => {
            return DeleteAdministratorsSuccess();
          }),
          catchError((errorResponse: any) => {
            return of(DeleteAdministratorsError({error: errorResponse}));
          })
        )
      )
    );
  });

  public updateAdminAccountStatusEffect$ = createEffect(() => {
    return this.action$.pipe(
      ofType(UpdateAdminAccountStatus),
      mergeMap((data) => {
        return of(...data.param).pipe(
          concatMap(req => this.userProfileService.updateAccountStatus$(req.userProfileIds, req.isDisable)),
          toArray(),
          map((result: boolean[]) => {
            return UpdateAdminAccountStatusSuccess({isAdminAccountStatusUpdateSuccessful: result.every(r => r)});
          }),
          catchError((err: any) => {
            return of(UpdateAdminAccountStatusError({ error: err }));
          })
        );
      })
    );
  });
}
